/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useState } from "react";
import { FaMoneyBill, FaMoneyBillAlt, FaMoneyBillWave, FaMoneyBillWaveAlt, FaMoneyCheck, FaMoneyCheckAlt, FaRegMoneyBillAlt } from "react-icons/fa";

// api
import feeApi from "../../api/Fees";

//css
import "../dashboard/Dashboard.css";

//components
import Card from "../../components/card/Card";
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import StatCard from "../../components/statcard/StatCard";

//data
import { empty, errorResponse, isObject, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import BoxLoading from "../../components/skeleton/BoxLoading";
import colors from "../../config/colors";
import FeeWrapper from "../../components/appWrapper/FeeWrapper";

const FeeDashboard = ({ ...props }) => {
  // stat status
  const [isFeesStatLoading, setIsFeesStatLoading] =
    useState(false);
  const [feesStatCount, setFeesStatCount] = useState({});

  const toastTR = useRef(null);

  useEffect(() => {
    getFeesStatCount();
  }, []);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  const getFeesStatCount = async () => {
     if (isFeesStatLoading) setIsFeesStatLoading(true);
    try {
      const response = await feeApi.getFeesStatCount();
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Failed to fetch fee stat counts!"
            : "Failed to fetch fee stat counts"
        );
      }

      const data =
        isObject(response_data?.response)
          ? response_data.response
          : {};
      setFeesStatCount(data);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsFeesStatLoading(false);
    }
  };

  return (
    <>
      <FeeWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Finance Dashboard" />
          {/* end menu header */}
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div className="w-100pc">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Fees"
                        entry={feesStatCount?.getFeesCount || 0}
                        icon={
                          <FaMoneyBill size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Current Fees"
                        entry={feesStatCount?.getCurrentFeesCount || 0}
                        icon={
                          <FaMoneyBillAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Active Fees"
                        entry={feesStatCount?.getActiveFeesCount || 0}
                        icon={
                          <FaMoneyCheck size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of In-Active Fees"
                        entry={feesStatCount?.getInActiveFeesCount || 0}
                        icon={
                          <FaMoneyBillWaveAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              <div className="top_stat_box">
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Fee Categories"
                        entry={feesStatCount?.getFeeCategoriesCount || 0}
                        icon={
                          <FaMoneyBillWave size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Active Fee Categories"
                        entry={feesStatCount?.getActiveFeeCategoriesCount || 0}
                        icon={
                          <FaMoneyCheckAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isFeesStatLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of In-Active Fee Categories"
                        entry={feesStatCount?.getInActiveFeeCategoriesCount || 0}
                        icon={
                          <FaRegMoneyBillAlt size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

            </div>
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </FeeWrapper>
    </>
  );
};

export default FeeDashboard;
